import { Decoder, field, succeed } from 'jsonous';
import { stringOptionsContentDecoder } from '../../../components/GenericSortFilter/Decoders';
import { resourceDecoder } from '../../../Resource/Decoders';
import { ParticipantsOptions, ParticipantsOptionsResource } from '../Types';

const participantsOptionsDecoder: Decoder<ParticipantsOptions> = succeed({})
  .assign('loginActivities', field('login_activities', stringOptionsContentDecoder))
  .assign('userGroups', field('user_groups', stringOptionsContentDecoder))
  .assign('learningCollections', field('learning_collections', stringOptionsContentDecoder))
  .assign('licenses', field('licenses', stringOptionsContentDecoder))
  .assign('licenseTypes', field('license_types', stringOptionsContentDecoder))
  .assign('licenseStartDates', field('license_start_dates', stringOptionsContentDecoder))
  .assign('licenseStatuses', field('license_statuses', stringOptionsContentDecoder))
  .assign('programs', field('programs', stringOptionsContentDecoder));

export const participantsOptionsResourceDecoder: Decoder<ParticipantsOptionsResource> =
  resourceDecoder(participantsOptionsDecoder);
